import { Injectable } from '@angular/core';
import { CXoneDigitalClient } from '@nice-devone/digital-sdk';
import { Subject } from 'rxjs';
import { LoggerService } from '../../../core/services/logger.service';
import { DigitalContactStatusAgent } from 'src/app/shared/enums/digital-contact-status-agent.enum';
import { EventHandlerService } from '../../services/event-handler.service';
import { ContatoEvento } from 'src/app/shared/models/contato-evento.models';
import { FocusEventDTO, FocusEventSource } from "src/app/components/pessoa-fisica/domain/ContactCenter/FocusEventDTO";
export type EventType = 'CaseInboxAssigned' | 'CaseInboxUnassigned'
@Injectable({
  providedIn: 'root',
})
export class SdkDigitalService {
  private cxoneDigital = CXoneDigitalClient.instance;
  private contatoEvento: ContatoEvento = { id: '', status: '' };
  public onDigitalContactEvent$ = new Subject<any>();
  public onFocusEvent$ = new Subject<FocusEventDTO>();

  constructor(
    private logger: LoggerService,
    private eventHandler: EventHandlerService,
  ) {}

  async initializeEvents() {
    try {
      this.logger.info('SDK-DIGITAL - Inicializando SDK DIGITAL...');
      await this.cxoneDigital.initDigitalEngagement();
      this.logger.info('SDK-DIGITAL - instância do SDK DIGITAL inicializada com sucesso.');

      this.cxoneDigital.digitalContactManager.onDigitalContactEvent?.subscribe(
        (onDigitalContactEvent: any) => {
          this.onDigitalContactEvent$.next(onDigitalContactEvent);
        },
      );
    } catch (error) {
      this.logger.error('SDK-DIGITAL - ERROR AO OUVIR EVENTOS: ', error);
      //throw new Error('SDK-DIGITAL - ERROR AO OUVIR EVENTOS', { cause: error });
      throw error;
    }
  }
}
